/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Card Status
 */
export type GetCardAccountsResponseDataItemCardsItemStatus = typeof GetCardAccountsResponseDataItemCardsItemStatus[keyof typeof GetCardAccountsResponseDataItemCardsItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCardAccountsResponseDataItemCardsItemStatus = {
  INACTIVE: 'INACTIVE',
  ACTIVE: 'ACTIVE',
  PENDING_ACTIVATION: 'PENDING_ACTIVATION',
  LOCKED: 'LOCKED',
  SUSPENDED: 'SUSPENDED',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED',
  PENDING_ISSUE: 'PENDING_ISSUE',
} as const;
